export const UNKNOWN_ERROR =
	'An unknown error has occurred! Please try again later';
export const USERNAME_MISSING_ERROR = 'Please enter a username, try again.';
export const USERNAME_NOTFOUND_ERROR =
	'We could not find the username you entered. Please check your username and try again.';
export const PASS_INCORRECT_ERROR =
	'The password you entered is incorrect, try again.';
export const PASS_MISSING_ERROR = 'Please enter a password, try again.';
export const DATANAME_MISSING_ERROR = 'Please enter a dataname, try again.';

export const ServerErrors = {
	UnknownError: {
		message: UNKNOWN_ERROR,
	},
	UsernameMissing: {
		message: USERNAME_MISSING_ERROR,
	},
	UsernameIncorrect: {
		message: USERNAME_NOTFOUND_ERROR,
	},
	PasswordIncorrect: {
		message: PASS_INCORRECT_ERROR,
	},
	PasswordMissing: { message: PASS_MISSING_ERROR },
	DatanameMissing: {
		message: DATANAME_MISSING_ERROR,
	},
};
